import {AppCategory} from '@web-catalog/types';

export const findCategoryData = (
  categories: Array<AppCategory>,
  category: string,
) =>
  categories
    ?.filter((cat: AppCategory) => cat.appCount !== 0)
    .find((cat: AppCategory) => cat.category.toLowerCase() === category) ||
  null;
